import React from 'react';
import classnames from 'classnames';
import classes from './short-underline-input.scss';
export const ShortUnderlineInput = ({
  onChange = () => undefined,
  onFocus = () => undefined,
  onBlur = () => undefined,
  className = undefined,
  value = undefined,
  dataInput = '',
  dataPerSizeInput = '',
  dataColorName = '',
  name = '',
  disabled = false,
  short = true,
  type = 'text',
  viewMode = false,
  id
}) => /*#__PURE__*/React.createElement("input", {
  className: classnames(classes.input, classes.pink, {
    [classes.short]: short,
    [classes.greyedOut]: disabled,
    [classes.viewMode]: viewMode
  }, className),
  id: id,
  type: type,
  "data-input": dataInput,
  "data-color-name": dataColorName,
  "data-per-size-input": dataPerSizeInput,
  value: value,
  name: name,
  onChange: onChange,
  onFocus: onFocus,
  onBlur: onBlur,
  disabled: disabled || viewMode
});